import { defaultLocale, localeOptions } from "../../constants/defaultValues";

import {
  CHANGE_LOCALE,
  HOTEL_SETTINGS_GET,
  HOTEL_SETTINGS_SUCCESS,
  HOTEL_SETTINGS_ERROR,
  SHOW_TOAST_SET,
  FORCE_RELOAD,
  GROUP_NAMES_GET,
  GROUP_NAMES_GET_SUCCESS,
  GROUP_NAMES_GET_ERROR
} from "../actions";

export const INIT_STATE = {
  locale:
    localStorage.getItem("currentLanguage") && localeOptions.filter(x => x.id === localStorage.getItem("currentLanguage")).length > 0
      ? localStorage.getItem("currentLanguage")
      : defaultLocale,
  hotelConfig: {},
  isSettingsLoaded: false,
  error: null,
  showToast: false,
  force_reload: false,
  groupNames: {}
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_LOCALE:
      return { ...state, locale: action.payload };
    case HOTEL_SETTINGS_GET:
      return { ...state, isSettingsLoaded: false };
    case HOTEL_SETTINGS_SUCCESS:
      return {
        ...state,
        isSettingsLoaded: true,
        error: null,
        showToast: false,
        hotelConfig: action.payload,
        force_reload: false
      };
    case HOTEL_SETTINGS_ERROR:
      return { ...state, isSettingsLoaded: true, error: action.payload, showToast: true };
    case SHOW_TOAST_SET:
      return { ...state, showToast: action.payload };
    case FORCE_RELOAD:
      return { ...state, force_reload: true };
    case GROUP_NAMES_GET:
      return { ...state, isLoading: true, groupNames: {} };
    case GROUP_NAMES_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        groupNames: action.payload
      };
    case GROUP_NAMES_GET_ERROR:
      return { ...state, isLoading: true, groupNames: null };
    default:
      return state;
  }
};
